import { render, staticRenderFns } from "./shortcutBtn.vue?vue&type=template&id=c2341692&scoped=true"
import script from "./shortcutBtn.vue?vue&type=script&lang=js"
export * from "./shortcutBtn.vue?vue&type=script&lang=js"
import style0 from "./shortcutBtn.vue?vue&type=style&index=0&id=c2341692&prod&lang=less&scoped=true"
import style1 from "./shortcutBtn.vue?vue&type=style&index=1&id=c2341692&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2341692",
  null
  
)

export default component.exports